<ng-container *transloco="let t">
  <div class="certificate-form">
    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('Patient history') }}</mat-label>
      <textarea matInput rows="5" [formControl]="patientHistory"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('Findings and therapy') }}</mat-label>
      <textarea matInput rows="5" [formControl]="findingsAndTherapy"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('Note') }}</mat-label>
      <textarea matInput rows="3" [formControl]="notes"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput [formControl]="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
